import React from "react";
import { TableCell, TableRow } from "../../design/table";
import { ParentingPlan } from "../../models/ParentingPlan";
import moment from "moment";
import ParentingPlanStatusBadge from "../../components/Badges/ParentingPlanStatusBadge";

interface Props {
  parentingPlan: ParentingPlan;
}

const ParentingPlanListItem: React.FC<Props> = ({ parentingPlan }) => {
  return (
    <TableRow
      key={parentingPlan._id}
      href={`/parenting-plan/${parentingPlan._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="flex items-center gap-2">
        <div className="flex-col items-start">
          <span className="font-bold">{parentingPlan.name}</span>
        </div>
      </TableCell>
      <TableCell>
        <ParentingPlanStatusBadge status={parentingPlan.status} />
      </TableCell>
      <TableCell>
        {moment(parentingPlan.effectiveDate).format("MMMM D, YYYY")}
      </TableCell>
      <TableCell>
        {parentingPlan.expirationDate
          ? moment(parentingPlan.expirationDate).format("MMMM D, YYYY")
          : "N/A"}
      </TableCell>
      <TableCell className="text-right">
        <span className="text-sm">
          {moment(parentingPlan.updatedAt).format("MMMM D, YYYY")}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default ParentingPlanListItem;
